import { Box } from '@wix/design-system';
import React from 'react';
import WixStudioLogo from '../../assets/images/wix-studio-logo.svg';
import { SwitchPlanHeaderBanner } from './SwitchPlanHeaderBanner';
export const HeaderBanner = _ref => {
  let {
    shouldShowSwitchPlanBanner
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    minHeight: "42px",
    width: "100%",
    verticalAlign: "middle",
    padding: "0 12px",
    boxSizing: "border-box",
    height: "50px"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(WixStudioLogo, null)), shouldShowSwitchPlanBanner && /*#__PURE__*/React.createElement(SwitchPlanHeaderBanner, null));
};
//# sourceMappingURL=HeaderBanner.js.map